import DocumentLine from "./DocumentLine";

export default function DocumentLines({ items }: any) {
  return (
    <div className="border border-black  mt-2 text-xs">
      <div className="grid grid-cols-12 border-b  border-black  bg-gray-200">
        <div className="col-span-5 p-1 font-bold border-r border-black  text-left">
          Description of Goods / Services
        </div>
        <div className="col-span-1 p-1 font-bold border-r border-black  text-center">
          Qty
        </div>
        <div className="col-span-2 p-1 font-bold border-r border-black  text-center">
          Unit Price
        </div>
        <div className="col-span-2 p-1 font-bold border-r border-black  text-center">
          Unit Des.
        </div>
        <div className="col-span-2 p-1 font-bold text-center">Net Total</div>
      </div>
      <div className="">
        {items.map((item: any, i: any) => (
          <DocumentLine
            style={{ color: "red" }}
            key={i + item._id}
            index={i}
            entries={[]}
            parts={[]}
            service_id={1}
            item={item}
          />
        ))}
      </div>
    </div>
  );
}
